// Third Party
import * as React from 'react';
import cx from 'classnames';
import { ResponsiveFontSize } from './responsive-font-size';
import { Icon, IconNames } from '@components/icon';

export interface IAlphatarProps {
  firstName?: string;
  lastName?: string;
  shape: 'circle' | 'square';
}

export const Alphatar: React.FC<IAlphatarProps> = ({
  firstName,
  lastName,
  shape = 'circle',
}) => {
  const displayName = () => {
    if (firstName && lastName) {
      return firstName[0] + lastName[0];
    }
    if (firstName) {
      return firstName[0];
    }

    if (lastName) {
      return lastName[0];
    }

    return '?';
  };

  return (
    <div
      className={cx(
        'p-2 aspect-[1] w-full h-full border-[1.5px] border-primary-main rounded-full',
        {
          'rounded-full': shape === 'circle',
          'rounded-2xl': shape === 'square',
        }
      )}
    >
      <div className="flex flex-col h-full justify-center uppercase text-primary-main text-center">
        {!firstName && !lastName && (
          <Icon className="h-4/6 w-4/6 m-auto pb-0.5" name={IconNames.USER} />
        )}
        {(firstName || lastName) && (
          <div className="h-2/3 w-full m-auto">
            <ResponsiveFontSize ratio={0.68}>
              {displayName()}
            </ResponsiveFontSize>
          </div>
        )}
      </div>
    </div>
  );
};
